import React, { memo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { CancelToken, isCancel } from 'axios';

import TemplateDashboardService from '../../Services/TemplateDashboardService';
import BasicDeleteConfirmationModal from '../BasicDeleteConfirmationModal';

export default memo(DeleteTemplateDashboardModal);

function DeleteTemplateDashboardModal(props) {
  const [state, updateState] = useState({
    deleteRequestPending: false,
    error: '',
  });
  const source = CancelToken.source();

  const handleDelete = async () => {
    try {
      updateState({ ...state, deleteRequestPending: true });
      await new TemplateDashboardService().deleteTemplateDashboard(
        props.gtemplateID,
        props.dashboard._id,
        source.token
      );
      props.handleDashboardDeleted(props.dashboard._id);
    } catch (err) {
      if (isCancel(err)) return;

      const error = err.response?.data?.message ?? err.message;
      updateState({ error, deleteRequestPending: false });
    }
  };

  useEffect(() => source.cancel, []);

  return (
    <BasicDeleteConfirmationModal
      {...props}
      deleteRequestPending={state.deleteRequestPending}
      error={state.error}
      handleDelete={handleDelete}
      modalData={{
        itemName: props.dashboard.name,
        itemType: 'asset model dashboard',
      }}
    />
  );
}

DeleteTemplateDashboardModal.propTypes = {
  dashboard: PropTypes.shape({ _id: PropTypes.string, name: PropTypes.string }),
  gtemplateID: PropTypes.string,
  handleDashboardDeleted: PropTypes.func,
  isOpen: PropTypes.bool,
  toggleModal: PropTypes.func,
};
